var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import React, { Suspense } from 'react';
import { Box, ChakraProvider, Flex, extendTheme } from '@chakra-ui/react';
import { MultiSelectTheme } from 'chakra-multiselect';
import { RootStore, StoreContext } from '@/app/uistore/Rootstore';
import { Bootstrapping } from './view/Bootstrapping';
import { observer } from 'mobx-react';
import { AppHeader } from '@/app/view/AppHeader';
import { AppState } from '@/share/AppState';
import { Register } from '@/app/view/Register';
import { LetrwingAlertDialog } from '@/app/components/AlertDialog';
import { ConfirmDialog } from './components/ConfirmDialog';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import { LoginView } from '@/app/view/LoginView';
import { WorkingDialog } from './UIComponents/WorkingDialog';
import { PdfViewerState } from './UIComponents/PDFViewer';
import 'react-medium-image-zoom/dist/styles.css';
import { APPDown } from './UIComponents/AppDown';
import { LoginViaDevice } from './view/LoginViaDevice';
import { MediaCall } from '@/media/MediaCall';
import { MediaPicker } from '@/media/MediaPicker';
import { HiddenBox } from '@/media/HiddenBox';
import { AppColor } from './const/AppDefaults';
import { DisplayRecoveryDialog } from './UIComponents/DisplayRecoverBoxDialog';
import { RecoveryCodeDialog } from './UIComponents/RecoveryCodeDialog';
import { ResetPassword } from './UIComponents/ResetPassword';
import { FloatingObjectViewer } from './UIComponents/FloatingObjectViewer';
import { ObjectChooserDialog } from './UIComponents/ObjectChooser';
import { AddEventDialog } from './UIComponents/AddEvent';
import { AddMiscContact } from './UIComponents/AddMiscContact';
import { NewDatasheetDialog } from './UIComponents/NewDatasheetDialog';
import { SchemaDialog } from './UIComponents/AddSchema';
import { DatasheetDialog } from './UIComponents/DatasheetDialog';
import { FloatingDatasheetViewer } from './UIComponents/FloatingDatasheetDialog';
import { BeatLoader } from 'react-spinners';
import { TemplateSchemaDialog } from './UIComponents/TemplateSchemaDialog';
import { AdminFloatingDatasheetViewer } from './admin/UIComponents/AdminFloatingDatasheetViewer';
import { AdminFloatingObjectViewer } from './admin/UIComponents/AdminFloatingObjectViewer';
const theme = extendTheme({
    components: {
        MultiSelect: MultiSelectTheme
    },
    colors: {
        lwcolor: {
            50: "#516a82",
            100: "#516a82",
            500: "#516a82",
        }
    }
});
const MainApp = React.lazy(async () => await import("./view/MainApp"));
let App = class App extends React.Component {
    constructor(props) {
        super(props);
        this.hidden = true;
        this.rstore = new RootStore();
    }
    componentDidMount() {
        if (this.rstore.authStore.appstate === AppState.Unknown) {
            this.restart();
        }
    }
    componentDidUpdate() {
        if (this.hidden && this.rstore.authStore.appstate !== AppState.Unknown) {
            this.showRoot();
            this.hidden = false;
        }
        else {
            this.restart();
        }
    }
    restart() {
        if (this.rstore.authStore.appstate === AppState.Unknown) {
            this.hidden = true;
            this.showSvg();
            this.rstore.authStore.checkAppState();
        }
    }
    showSvg() {
        const loading = document.getElementById("loading_svg");
        const root = document.getElementById("root");
        if (loading) {
            loading.style.display = "block";
        }
        if (root) {
            root.style.display = "none";
        }
    }
    showRoot() {
        const loading = document.getElementById("loading_svg");
        const root = document.getElementById("root");
        if (loading) {
            loading.style.display = "none";
        }
        if (root) {
            root.style.display = "block";
        }
    }
    paste(ev, rstore) {
        if (ev.clipboardData.items.length > 0 || ev.clipboardData.files.length > 0) {
            if (ev.clipboardData.items.length > 0) {
                // Use DataTransferItemList interface to access the file(s)
                for (var i = 0; i < ev.clipboardData.items.length; i++) {
                    // If dropped items aren't files, reject them
                    if (ev.clipboardData.items[i].kind === 'file') {
                        const file = ev.clipboardData.items[i].getAsFile();
                        if (file === null) {
                            continue;
                        }
                        rstore.projectStore.fileuploadstate.addSelectedFile(file);
                    }
                }
            }
            else if (ev.clipboardData.files.length > 0) {
                // Use DataTransfer interface to access the file(s)
                for (var i = 0; i < ev.clipboardData.files.length; i++) {
                    const file = ev.clipboardData.files[i];
                    if (file === null) {
                        continue;
                    }
                    rstore.projectStore.fileuploadstate.addSelectedFile(file);
                }
            }
            if (rstore.projectStore.fileuploadstate.selectedFiles.length > 0) {
                rstore.projectStore.showDropZone(false);
                rstore.projectStore.fileuploadstate.fileUploadedCb = (details) => {
                    rstore.projectStore.addDocumentObject(details);
                };
                rstore.projectStore.fileuploadstate.letrid = rstore.projectStore.activeletrid;
                rstore.projectStore.fileuploadstate.setOpen(true);
                rstore.projectStore.fileuploadstate.basedialogState.setDisableOkButton(false);
            }
        }
    }
    render() {
        return (React.createElement(StoreContext.Provider, { value: this.rstore },
            React.createElement(ChakraProvider, { theme: theme },
                this.rstore.mediastore.showdevicepicker && React.createElement(MediaPicker, null),
                this.rstore.mediastore.showhiddenbox && React.createElement(HiddenBox, null),
                this.rstore.mediastore.open && React.createElement(MediaCall, null),
                React.createElement(Box, { minH: '100vh', onPaste: (e) => {
                        if (this.rstore.authStore.appstate === AppState.LoggedIn && this.rstore.homeViewStore.activeTab === 'letrs') {
                            this.paste(e, this.rstore);
                        }
                    }, background: this.rstore.authStore.appstate === AppState.Login || this.rstore.authStore.appstate === AppState.Logout ||
                        this.rstore.authStore.appstate === AppState.Register ||
                        this.rstore.authStore.appstate === AppState.ResetPassword ||
                        this.rstore.authStore.appstate === AppState.APPDown ? AppColor.LoginScreenBackground : '' },
                    this.rstore.authStore.appstate === AppState.APPDown
                        && React.createElement(APPDown, null),
                    this.rstore.authStore.appstate !== AppState.Login
                        && this.rstore.authStore.appstate !== AppState.Logout
                        && this.rstore.authStore.appstate !== AppState.Register &&
                        this.rstore.authStore.appstate !== AppState.ResetPassword
                        &&
                            this.rstore.authStore.appstate !== AppState.APPDown && !PdfViewerState.show
                        && React.createElement(AppHeader, null),
                    React.createElement(LetrwingAlertDialog, null),
                    React.createElement(ConfirmDialog, null),
                    React.createElement(WorkingDialog, null),
                    React.createElement(DisplayRecoveryDialog, null),
                    React.createElement(RecoveryCodeDialog, null),
                    React.createElement(AddMiscContact, null),
                    React.createElement(SchemaDialog, null),
                    React.createElement(TemplateSchemaDialog, null),
                    React.createElement(DatasheetDialog, null),
                    React.createElement(NewDatasheetDialog, null),
                    React.createElement(ObjectChooserDialog, null),
                    React.createElement(AddEventDialog, null),
                    React.createElement(FloatingObjectViewer, null),
                    React.createElement(AdminFloatingObjectViewer, null),
                    React.createElement(FloatingDatasheetViewer, null),
                    React.createElement(AdminFloatingDatasheetViewer, null),
                    this.rstore.authStore.appstate === AppState.Unknown &&
                        React.createElement(Flex, { h: '92vh', w: '100%', alignItems: 'center', justifyContent: 'center' },
                            React.createElement(Bootstrapping, null)),
                    this.rstore.authStore.appstate === AppState.Register && !this.rstore.authStore.showLoginViaDevice && React.createElement(Register, null),
                    this.rstore.authStore.appstate === AppState.ResetPassword && !this.rstore.authStore.showLoginViaDevice && React.createElement(ResetPassword, null),
                    this.rstore.authStore.appstate === AppState.Register && this.rstore.authStore.showLoginViaDevice && React.createElement(LoginViaDevice, null),
                    !this.rstore.authStore.showLoginViaDevice && (this.rstore.authStore.appstate === AppState.Login || this.rstore.authStore.appstate === AppState.Logout)
                        && React.createElement(LoginView, null),
                    this.rstore.authStore.appstate === AppState.LoggedIn &&
                        React.createElement(Suspense, { fallback: React.createElement(Flex, { height: window.innerHeight - 72, justify: 'center', align: 'center' },
                                React.createElement(BeatLoader, { color: AppColor.MainLoaderColor })) },
                            React.createElement(MainApp, null))))));
    }
};
App = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], App);
export { App };
